/** @format */
import { client } from '@toucan/client/global/axios';
import { Market, OperationFixture } from '@toucan/client/global/market';

// eslint-disable-next-line @mpb-com/mpb/pure-request-functions -- Legacy code: do not use as an example.
export async function getOperations() {
    const { data } = await client.get<{ operations: OperationFixture[] }>(
        '/fixtures/operations'
    );

    return data;
}

// eslint-disable-next-line @mpb-com/mpb/pure-request-functions -- Legacy code: do not use as an example.
export async function getMarkets() {
    const { data } = await client.get<{ markets: Market[] }>(
        '/fixtures/markets'
    );

    return data;
}
